import type { DownloadsView } from "~/features/downloads/adapter";
import { DownloadsProvider } from "~/features/downloads/context";
import { DownloadsHeader } from "~/features/downloads/downloads-header";
import { DownloadsFilters } from "~/features/downloads/filters";
import { Warnings } from "~/features/downloads/warnings";
import { DownloadsTables } from "~/features/downloads/downloads-tables";
import { HardwareAndAccessoriesTable } from "~/features/downloads/table/hardware-and-accessories-table";
import { DirectTable } from "~/features/downloads/table/direct-table";
import { hasItems } from "~/features/app/utils";
type Props = {
  title?: string;
  /** Already-adapted view built from the Downloads (Products (new)) schema. */
  view: DownloadsView | null;
};

/**
 * Sanity-native downloads overview: the hardware/firmware filter bar, warnings,
 * and the seven download tables. Called from the `productDownloadsTable`
 * pageBuilder section, which builds the view from the Downloads docs.
 */
export function SanityDownloads(props: Props) {
  const {
    view,
    title
  } = props;
  if (!view) return null;
  const {
    tables
  } = view;
  const hasContent = hasItems(view.hardwareOptions) || hasItems(view.firmwareOptions) || Object.values(tables).some(rows => hasItems(rows));
  if (!hasContent) {
    return null;
  }
  return <DownloadsProvider initialHardwareVersion={view.hardwareOptions[0]?.slug || ""} initialFirmwareVersion={view.firmwareOptions[0]?.slug || ""}>
      {title && <DownloadsHeader title={title} />}
      <DownloadsFilters hardwareOptions={view.hardwareOptions} firmwareOptions={view.firmwareOptions} tooltips={view.tooltips} />
      <Warnings warnings={view.warnings} />
      <DownloadsTables>
        <HardwareAndAccessoriesTable hardwareRows={tables.hardwareTable} accessoryRows={tables.hardwareAccessoriesTable} />
        <DirectTable title="Firmware" rows={tables.firmwareTable} />
        <DirectTable title="Guides and Resources" rows={tables.guidesAndResourcesTable} />
        <DirectTable title="Developer Tools" rows={tables.developerToolsTable} />
        <DirectTable title="Ouster Studio Visualizer" rows={tables.ousterStudioVisualizerTable} />
      </DownloadsTables>
    </DownloadsProvider>;
}